export default {
  editor_button_text_placeholderRequestNumber: 'N\u00famero de solicitud',
  contactCard_default_status:
    'A\u00fan no est\u00e1 en Flock, pero puede enviar un mensaje para avisarle',
};
